import React, { useEffect, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
   ShowError, confirmationDialog, 
   JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
   JSON_KEY_SUBMITTER, 
   ITEM_CREATE, ITEM_MODIFY, 
   EVENT_TYPE_TRADING_RULES_MODIFY, EVENT_TYPE_TRADING_RULES_CREATE, JSON_KEY_DESCRIPTION, NO,
   SwitchField,
   TRADING_RULES_NAME_NONE, TRADING_RULES_NONE, TRADING_RULES_FULL_HOLDINGS_CHECK, 
   TRADING_RULES_NAME_FULL_HOLDINGS_CHECK,
   TRADING_RULES_BOTH, TRADING_RULES_ONE_SIDE, TRADING_RULES_NAME_ONE_SIDE, TRADING_RULES_NAME_BOTH,
   AUCTION_OPEN, AUCTION_CLOSE, AUCTION_LAST, AUCTION_NONE,
   NAME_AUCTION_NONE, NAME_AUCTION_LAST, NAME_AUCTION_CLOSE, NAME_AUCTION_OPEN,
   JSON_KEY_TR_ORDER_ENTRY, JSON_KEY_TR_ORDER_AMEND, JSON_KEY_TR_ORDER_WITHDRAW,
   JSON_KEY_TR_BETTER_PRICE, JSON_KEY_TR_BETTER_QUANTITY, JSON_KEY_TR_REF_PRICE_CHECK, JSON_KEY_TR_REF_PRICE_PERCENT,
   JSON_KEY_TR_TRADING_ACCOUNT, JSON_KEY_TR_HOLDINGS, JSON_KEY_TR_OT_LIMIT,
   JSON_KEY_TR_OT_MARKET, JSON_KEY_TR_OT_HIDDEN, JSON_KEY_TR_OT_FOK, JSON_KEY_TR_DURATION_IMMEDIATE,
   JSON_KEY_TR_DURATION_DAY, JSON_KEY_TR_DURATION_GTC, JSON_KEY_TR_LOAD_DB_ORDERS, JSON_KEY_TR_MIN_VALUE,
   JSON_KEY_TR_MAX_VALUE, JSON_KEY_TR_HIDDEN_QTY_PERCENT, JSON_KEY_TR_AUCTION_START, JSON_KEY_TR_AUCTION_END,
   JSON_KEY_TR_AUCTION_TYPE, JSON_KEY_TR_DUMP_TABLES,
   JSON_KEY_CODE,
   TRADING_RULES_APPROVAL_HOLDINGS_CHECK,
   TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK,
   YES,
   JSON_KEY_TR_CAN_MATCH,
   handleIntegerChange,
   tableOptions,
   ConvertTableName,
   JSON_KEY_TR_PRE_FUNCTION,
   JSON_KEY_TR_POST_FUNCTION,
   JSON_KEY_TR_DELETE_REDUNDANT_ORDERS,
   NAME_YES,
   JSON_KEY_TR_CHECKPOINT,
   CHECKPOINT_NAME_ALL_SERVERS,
   CHECKPOINT_NAME_DESIGNATED_SERVER,
   CHECKPOINT_DESIGNATED_SERVER,
   CHECKPOINT_ALL_SERVERS,
   ConvertCheckPointToId,
   JSON_KEY_TR_DURATION_SESSION,
   JSON_KEY_TR_OT_TRIGGER,
   JSON_KEY_TR_OT_SESSION,
   SESSION_TYPE_NOT_SET,
   SESSION_TYPE_PREOPEN,
   SESSION_TYPE_OPEN,
   SESSION_TYPE_CLOSE,
   SESSION_TYPE_AUCTION,
   SESSION_TYPE_OTHER,
   NAME_SESSION_TYPE_OTHER,
   NAME_SESSION_TYPE_AUCTION,
   NAME_SESSION_TYPE_CLOSE,
   NAME_SESSION_TYPE_OPEN,
   NAME_SESSION_TYPE_PREOPEN,
   NAME_SESSION_TYPE_NOT_SET,
   POST_FUNCTION_FLAGS,
   JSON_KEY_TR_SESSION_TYPE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_TRADING_RULES_CREATE, MSGTYPE_TRADING_RULES_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, NarrowInputField } from "../../common/utilies";
import { ConvertFromTradingRulesValueName, ConvertToAuctionType, ConvertToSessionType } from "../../common/convert_functions";

const checkPointOptions = [
   { id: TRADING_RULES_NONE, name: TRADING_RULES_NAME_NONE },
   { id: CHECKPOINT_ALL_SERVERS, name: CHECKPOINT_NAME_ALL_SERVERS },
   { id: CHECKPOINT_DESIGNATED_SERVER, name: CHECKPOINT_NAME_DESIGNATED_SERVER },
];

const holdingsOptions = [
   { id: TRADING_RULES_NONE, name: TRADING_RULES_NAME_NONE },
   { id: TRADING_RULES_FULL_HOLDINGS_CHECK, name: TRADING_RULES_NAME_FULL_HOLDINGS_CHECK },
   { id: TRADING_RULES_APPROVAL_HOLDINGS_CHECK, name: TRADING_RULES_NAME_APPROVAL_HOLDINGS_CHECK },
   // { id: TRADING_RULES_PARENT_HOLDINGS_CHECK, name: TRADING_RULES_NAME_PARENT_HOLDINGS_CHECK },
];

const referencePriceOptions = [
   { id: NO, name: TRADING_RULES_NAME_NONE },
   { id: TRADING_RULES_BOTH, name: TRADING_RULES_NAME_BOTH },
   { id: TRADING_RULES_ONE_SIDE, name: TRADING_RULES_NAME_ONE_SIDE },
];

const auctionTypeOptions = [
   { id: AUCTION_NONE, name: NAME_AUCTION_NONE },
   { id: AUCTION_OPEN, name: NAME_AUCTION_OPEN },
   { id: AUCTION_CLOSE, name: NAME_AUCTION_CLOSE },
   { id: AUCTION_LAST, name: NAME_AUCTION_LAST },
];

const sessionTypeOptions = [
   { id: SESSION_TYPE_NOT_SET, name: NAME_SESSION_TYPE_NOT_SET },
   { id: SESSION_TYPE_PREOPEN, name: NAME_SESSION_TYPE_PREOPEN },
   { id: SESSION_TYPE_OPEN,    name: NAME_SESSION_TYPE_OPEN },
   { id: SESSION_TYPE_CLOSE,   name: NAME_SESSION_TYPE_CLOSE },
   { id: SESSION_TYPE_AUCTION, name: NAME_SESSION_TYPE_AUCTION },
   { id: SESSION_TYPE_OTHER,   name: NAME_SESSION_TYPE_OTHER },
];

const TradingRulesAdminForm = ({ rowData, onClose, tradingRulesOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // code and description
   const [code, setCode] = useState(rowData?.code);
   const [description, setDescription] = useState(rowData?.descr);

   // order functionality
   const [orderEntry, setOrderEntry] = useState(rowData?.oe === 'Yes' ? 'Y' : 'N');
   const [orderModify, setOrderModify] = useState(rowData?.oa === 'Yes' ? 'Y' : 'N');
   const [orderCancel, setOrderCancel] = useState(rowData?.ow === 'Yes' ? 'Y' : 'N');

   // order types
   const [limit, setLimit] = useState(rowData?.otl === 'Yes' ? 'Y' : 'N');
   const [market, setMarket] = useState(rowData?.otm === 'Yes' ? 'Y' : 'N');
   const [hidden, setHidden] = useState(rowData?.oth === 'Yes' ? 'Y' : 'N');
   const [fillOrKill, setFillOrKill] = useState(rowData?.otf === 'Yes' ? 'Y' : 'N');
   const [trigger, setTrigger] = useState(rowData?.ottr === 'Yes' ? 'Y' : 'N');
   const [sessionOrderType, setSessionOrderType] = useState(rowData?.ots === 'Yes' ? 'Y' : 'N');

   // duration
   const [immediate, setImmediate] = useState(rowData?.di === 'Yes' ? 'Y' : 'N');
   const [day, setDay] = useState(rowData?.dd === 'Yes' ? 'Y' : 'N');
   const [gtc, setGTC] = useState(rowData?.dg === 'Yes' ? 'Y' : 'N');
   const [session, setSession] = useState(rowData?.ds === 'Yes' ? 'Y' : 'N');

   // matching
   const [continuousMatching, setContinuousMatching] = useState(rowData?.cm === 'Yes' ? 'Y' : 'N');
   // const [uncrossing, setUncrossing] = useState(rowData?.un === 'Yes' ? 'Y' : 'N');

   // order settings
   const [loadDBOrders, setLoadDBOrders] = useState(rowData?.ldb === 'Yes' ? 'Y' : 'N');
   const [deleteRedundantOrders, setDeleteRedundantOrders] = useState(rowData?.dro === NAME_YES ? YES : NO);
   const [dumpTables, setDumpTables] = useState(ConvertTableName(rowData?.dt));
   const [checkPoint, setCheckPoint] = useState(ConvertCheckPointToId(rowData?.cp));


   // validation settings
   const [tradingAccount, setTradingAccount] = useState(rowData?.ta === 'Yes' ? 'Y' : 'N');
   const [holdingsCheck, setHoldingsCheck] = useState(ConvertFromTradingRulesValueName(rowData?.hld));

   // reference price
   const [referencePriceOption, setReferencePriceOption] = useState(ConvertFromTradingRulesValueName(rowData?.rpc));
   const [referencePricePercent, setReferencePricePercent] = useState(rowData?.rpp ?? '');

   // value settings
   const [maximumValue, setMaximumValue] = useState(rowData?.maxv ?? '');
   const [minimumValue, setMinimumValue] = useState(rowData?.minv ?? '');
   const [hiddenQtyPercent, setHiddenQtyPercent] = useState(rowData?.hqp ?? '');

   // pre and post functions
   // const [preFunction, setPreFunction] = useState(ConvertToPreFunction(rowData?.pre));
   // const [postFunction, setPostFunction] = useState(ConvertToPostFunction(rowData?.post));

   const [preFunctionFlags, setPreFunctionFlags] = useState({
      none: rowData?.pre === 0 || rowData?.pre === undefined || rowData?.pre === null,
   });

   const [postFunctionFlags, setPostFunctionFlags] = useState({
      closeIsLastAuctionPrice: (rowData?.post & POST_FUNCTION_FLAGS.CLOSE_IS_LAST_AUCTION_PRICE) !== 0,
      closeIsLtp: (rowData?.post & POST_FUNCTION_FLAGS.CLOSE_IS_LTP) !== 0,
      closeIsVwap: (rowData?.post & POST_FUNCTION_FLAGS.CLOSE_IS_VWAP) !== 0,
      withdrawSessionOrders: (rowData?.post & POST_FUNCTION_FLAGS.WITHDRAW_SESSION_ORDERS) !== 0,
      withdrawDayOrders: (rowData?.post & POST_FUNCTION_FLAGS.WITHDRAW_DAY_ORDERS) !== 0,
      removeOpenOrders: (rowData?.post & POST_FUNCTION_FLAGS.REMOVE_OPEN_ORDERS) !== 0,
   });

   // Helper to convert pre function flags to integer
   const getPreFunctionValue = () => {
      // Currently only NONE (0) is supported
      return 0;
   };

   // Helper to convert post function flags to integer
   const getPostFunctionValue = () => {
      let value = 0;
      if (postFunctionFlags.closeIsLastAuctionPrice) {
         value |= POST_FUNCTION_FLAGS.CLOSE_IS_LAST_AUCTION_PRICE;
      }
      if (postFunctionFlags.closeIsLtp) {
         value |= POST_FUNCTION_FLAGS.CLOSE_IS_LTP;
      }
      if (postFunctionFlags.closeIsVwap) {
         value |= POST_FUNCTION_FLAGS.CLOSE_IS_VWAP;
      }
      if (postFunctionFlags.withdrawSessionOrders) {
         value |= POST_FUNCTION_FLAGS.WITHDRAW_SESSION_ORDERS;
      }
      if (postFunctionFlags.withdrawDayOrders) {
         value |= POST_FUNCTION_FLAGS.WITHDRAW_DAY_ORDERS;
      }
      if (postFunctionFlags.removeOpenOrders) {
         value |= POST_FUNCTION_FLAGS.REMOVE_OPEN_ORDERS;
      }
      return value;
   };

   // Helper to toggle a post function flag
const exclusiveFlags = [
    'closeIsLastAuctionPrice',
    'closeIsLtp',
    'closeIsVwap'
];

const togglePostFunctionFlag = (flag) => {
    setPostFunctionFlags(prev => {
        const newValue = !prev[flag];

        // Start with the existing flags
        const updated = { ...prev };

        if (exclusiveFlags.includes(flag)) {
            // Turn all exclusive flags off
            exclusiveFlags.forEach(f => {
                updated[f] = false;
            });

            // Turn the selected one on (or leave all off if it was already on)
            updated[flag] = newValue;
        } else {
            // Normal toggle
            updated[flag] = newValue;
        }

        return updated;
    });
};

   // session type
   const [sessionType, setSessionType] = useState(ConvertToSessionType(rowData?.st));
   
   // better settings
   const [betterPrice, setBetterPrice] = useState(rowData?.bp === 'Yes' ? 'Y' : 'N');
   const [betterQuantity, setBetterQuantity] = useState(rowData?.bq === 'Yes' ? 'Y' : 'N');

   // auction settings
   const [auctionStart, setAuctionStart] = useState(rowData?.as === 'Yes' ? 'Y' : 'N');
   const [auctionEnd, setAuctionEnd] = useState(rowData?.ae === 'Yes' ? 'Y' : 'N');
   const [auctionType, setAuctionType] = useState(ConvertToAuctionType(rowData?.at));

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   const handleReferencePriceOptionChange = (e) => {
      const val = e && e.target ? e.target.value : e;

      setReferencePriceOption(val);

      if (val === TRADING_RULES_NONE) {
         setReferencePricePercent(""); // or null if your input expects that
      }
   };

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const buildPayload = () => {
      const payload = {};

      // Helper: only add if value is not null/empty
      // console.log('start min: ' << minimumValue << ", max: " << maximumValue);
      const addIfNotEmpty = (key, value) => {
         if (value !== null && value !== undefined && value !== '') {
            payload[key] = value;
         }
      };

      // Helper: only add if it's a valid number
      // const addIfValidNumber = (key, value) => {
      //    if (value !== null && value !== '') {
      //       // Remove % and trim spaces
      //       const cleaned = String(value).replace('%', '').trim();
      //       if (!isNaN(cleaned)) {
      //          payload[key] = Number(cleaned);
      //       }
      //    }
      // };

      const addIfValidNumber = (key, value) => {
         if (value == null || value === '') return;
         const cleaned = String(value)
            .replace(/[,%\s]/g, '') // remove commas, %, and spaces
            .replace(/[^0-9.-]/g, ''); // just in case, strip anything not number-related
         const num = parseFloat(cleaned);
         if (!isNaN(num)) payload[key] = num;
      };

      // Always required fields
      addIfNotEmpty(JSON_KEY_SUBMITTER, userId);
      addIfNotEmpty(JSON_KEY_CODE, code);
      addIfNotEmpty(JSON_KEY_DESCRIPTION, description);

      // Order functionality
      addIfNotEmpty(JSON_KEY_TR_ORDER_ENTRY, orderEntry);
      addIfNotEmpty(JSON_KEY_TR_ORDER_AMEND, orderModify);
      addIfNotEmpty(JSON_KEY_TR_ORDER_WITHDRAW, orderCancel);

      // Order types
      addIfNotEmpty(JSON_KEY_TR_OT_LIMIT, limit);
      addIfNotEmpty(JSON_KEY_TR_OT_MARKET, market);
      addIfNotEmpty(JSON_KEY_TR_OT_HIDDEN, hidden);
      addIfNotEmpty(JSON_KEY_TR_OT_FOK, fillOrKill);
      addIfNotEmpty(JSON_KEY_TR_OT_TRIGGER, trigger);
      addIfNotEmpty(JSON_KEY_TR_OT_SESSION, sessionOrderType);

      // Durations
      addIfNotEmpty(JSON_KEY_TR_DURATION_IMMEDIATE, immediate);
      addIfNotEmpty(JSON_KEY_TR_DURATION_DAY, day);
      addIfNotEmpty(JSON_KEY_TR_DURATION_GTC, gtc);
      addIfNotEmpty(JSON_KEY_TR_DURATION_SESSION, session);

      // Matching
      addIfNotEmpty(JSON_KEY_TR_CAN_MATCH, continuousMatching);
      // addIfNotEmpty(JSON_KEY_TR_UNCROSSING, uncrossing);

      // Other settings
      addIfNotEmpty(JSON_KEY_TR_LOAD_DB_ORDERS, loadDBOrders);
      addIfNotEmpty(JSON_KEY_TR_DUMP_TABLES, dumpTables);
      addIfNotEmpty(JSON_KEY_TR_CHECKPOINT, checkPoint);

      // Validation
      addIfNotEmpty(JSON_KEY_TR_TRADING_ACCOUNT, tradingAccount);
      addIfNotEmpty(JSON_KEY_TR_HOLDINGS, holdingsCheck);

      // Reference price
      addIfNotEmpty(JSON_KEY_TR_REF_PRICE_CHECK, referencePriceOption);
      addIfValidNumber(JSON_KEY_TR_REF_PRICE_PERCENT, referencePricePercent);

      // Order values (numbers only if valid)
      // console.log('min: ' << minimumValue << ", max: " << maximumValue);
      addIfValidNumber(JSON_KEY_TR_MAX_VALUE, maximumValue);
      addIfValidNumber(JSON_KEY_TR_MIN_VALUE, minimumValue);
      addIfValidNumber(JSON_KEY_TR_HIDDEN_QTY_PERCENT, hiddenQtyPercent);

      // Better validations
      addIfNotEmpty(JSON_KEY_TR_BETTER_PRICE, betterPrice);
      addIfNotEmpty(JSON_KEY_TR_BETTER_QUANTITY, betterQuantity);

      // pre and post functions
      addIfNotEmpty(JSON_KEY_TR_PRE_FUNCTION, getPreFunctionValue());
      addIfNotEmpty(JSON_KEY_TR_POST_FUNCTION, getPostFunctionValue());

      // Delete Redundant Orders
      addIfNotEmpty(JSON_KEY_TR_DELETE_REDUNDANT_ORDERS, deleteRedundantOrders);

      // Auction
      addIfNotEmpty(JSON_KEY_TR_AUCTION_START, auctionStart);
      addIfNotEmpty(JSON_KEY_TR_AUCTION_END, auctionEnd);
      addIfNotEmpty(JSON_KEY_TR_AUCTION_TYPE, auctionType);

      // Session Type
      addIfNotEmpty(JSON_KEY_TR_SESSION_TYPE, sessionType);

      return payload;
   };


   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = buildPayload();

      switch (submitItem) {

         case ITEM_CREATE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_TRADING_RULES_CREATE,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_RULES_CREATE,
               }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_TRADING_RULES_MODIFY,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_RULES_MODIFY,
               }
            );
            break;

         default:
            console.log("TradingRulessAdminForm unknown submit item");
      }
   };


   const ValidateFields = () => {      
      // console.log("Payload debug:", {
      //    [JSON_KEY_SUBMITTER]: userId,
      //    [JSON_KEY_CODE]: code,
      //    [JSON_KEY_DESCRIPTION]: description,

      //    // Order Functionality
      //    [JSON_KEY_TR_ORDER_ENTRY]: orderEntry,
      //    [JSON_KEY_TR_ORDER_AMEND]: orderModify,
      //    [JSON_KEY_TR_ORDER_WITHDRAW]: orderCancel,

      //    // Order Types
      //    [JSON_KEY_TR_OT_LIMIT]: limit,
      //    [JSON_KEY_TR_OT_MARKET]: market,
      //    [JSON_KEY_TR_OT_HIDDEN]: hidden,
      //    [JSON_KEY_TR_OT_FOK]: fillOrKill,

      //    // Durations
      //    [JSON_KEY_TR_DURATION_IMMEDIATE]: immediate,
      //    [JSON_KEY_TR_DURATION_DAY]: day,
      //    [JSON_KEY_TR_DURATION_GTC]: gtc,

      //    // Matching
      //    [JSON_KEY_TR_CAN_MATCH]: continuousMatching,
      //    // [JSON_KEY_TR_UNCROSSING]: uncrossing,

      //    // Other Settings
      //    [JSON_KEY_TR_LOAD_DB_ORDERS]: loadDBOrders,
      //    [JSON_KEY_TR_DUMP_TABLES]: dumpTables,

      //    // Validation
      //    [JSON_KEY_TR_TRADING_ACCOUNT]: tradingAccount,
      //    [JSON_KEY_TR_HOLDINGS]: holdingsCheck,

      //    // Reference Price
      //    [JSON_KEY_TR_REF_PRICE_CHECK]: referencePriceOption,
      //    [JSON_KEY_TR_REF_PRICE_PERCENT]: referencePriceOption,

      //    // Order Values
      //    [JSON_KEY_TR_MAX_VALUE]: maximumValue,
      //    [JSON_KEY_TR_MIN_VALUE]: minimumValue,
      //    [JSON_KEY_TR_HIDDEN_QTY_PERCENT]: hiddenQtyPercent,

      //    // Better Validations
      //    [JSON_KEY_TR_BETTER_PRICE]: betterPrice,
      //    [JSON_KEY_TR_BETTER_QUANTITY]: betterQuantity,

      //    // Auction
      //    [JSON_KEY_TR_AUCTION_START]: auctionStart,
      //    [JSON_KEY_TR_AUCTION_END]: auctionEnd,
      //    [JSON_KEY_TR_AUCTION_TYPE]: auctionType,
      // });
      
      if (!code) return "Code is missing";
      if (!description) return "Description is missing";

      // add check if ref pricecheck then it needs a percentage
      // console.log('ref price option: ', referencePriceOption, ', per: ', referencePricePercent);
      if ((referencePriceOption !== NO) && (!referencePricePercent || referencePricePercent.trim() === "")) {
         return "Missing Reference Price Percent";
      }

      if ((referencePriceOption === NO) && referencePricePercent) {
         return "Missing Reference Price Option";
      }

      //auction type only applicable at end
      // console.log('end: ', auctionEnd, ', type: ', auctionType);
      if ((auctionEnd === YES) && (auctionType === AUCTION_NONE)) {
         return "Missing Auction Type";
      }

      // cannot have both auction start and end
      // console.log('start: ', auctionStart, ', end: ', auctionEnd);
      if ((auctionStart === YES) && (auctionEnd === YES)) {
         return "Cannot have both Auction Start and End";
      }

      // auction type is not used with auction start
      // console.log('start: ', auctionStart, ', end: ', auctionEnd);
      if ((auctionStart === YES) && (auctionType !== AUCTION_NONE)) {
         return "Auction Type is not required with Auction Start, set to None";
      }

      // auction type is not used with auction start
      // console.log('start: ', auctionStart, ', end: ', auctionEnd);
      if ((auctionEnd === NO) && (auctionType !== AUCTION_NONE)) {
         return "Auction End needs to be set to YES when using Auction Type";
      }

      return null;
   };

   useEffect(() => {
   if (hidden === 'N') {
         setHiddenQtyPercent('');
      }
   }, [hidden]);

   // Inside TradingRulesAdminForm component
   const handleAuctionStartChange = (newVal) => {
      if (newVal === 'Y' && auctionEnd === 'Y') {
         setAuctionEnd('N');          // turn End OFF first
      }
      setAuctionStart(newVal);
   };

   const handleAuctionEndChange = (newVal) => {
      if (newVal === 'Y' && auctionStart === 'Y') {
         setAuctionStart('N');        // turn Start OFF first
      }
      setAuctionEnd(newVal);
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create TradingRules",
         text: `Creating new Trading Rule: ${code}`,
         item: ITEM_CREATE,
      });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify TradingRules",
         text: `Modifying Trading Rule: ${code}`,
         item: ITEM_MODIFY,
      });
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.code || '');
         setDescription(rowData.descr || '');
   }, [rowData]);

   return (
      <div className="admin-extra-large-form">
         <div className="admin-extra-large-tabs">
         <h2 className="center-heading">TradingRules Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-extra-large-tabs" >
            <TabList>
               <Tab>Modify TradingRules</Tab>
               <Tab>Create TradingRules</Tab>
            </TabList>

            {/* Tab 1: Modify TradingRules */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>

               <div className="d-flex align-items-start mb-3" style={{ gap: '0rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '100px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Code:
                  </div>

                  <div className="d-flex gap-4">
                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("", code, tradingRulesOptions, setCode)}
                        </div>
                     </div>
                  </div>
               </div>

               <div>
                  <NarrowInputField label="Description" value={description} onChange={setDescription} gap={"5.5rem"} width={'780px'}/>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Order Functionality:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Order Entry" value={orderEntry} onChange={setOrderEntry} />
                     <SwitchField label="Order Modify" value={orderModify} onChange={setOrderModify} />
                     <SwitchField label="Order Cancel" value={orderCancel} onChange={setOrderCancel} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Order Types:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Limit" value={limit} onChange={setLimit} />
                     <SwitchField label="Market" value={market} onChange={setMarket} />
                     <SwitchField label="Hidden" value={hidden} onChange={setHidden} />
                     <SwitchField label="Fill or Kill" value={fillOrKill} onChange={setFillOrKill} />
                     <SwitchField label="Schedule" value={sessionOrderType} onChange={setSessionOrderType} />
                     <SwitchField label="Trigger" value={trigger} onChange={setTrigger} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Durations:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Immediate" value={immediate} onChange={setImmediate} />
                     <SwitchField label="Session" value={session} onChange={setSession} />
                     <SwitchField label="Day" value={day} onChange={setDay} />
                     <SwitchField label="GTC" value={gtc} onChange={setGTC} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Matching:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Continuous Matching" value={continuousMatching} onChange={setContinuousMatching} />
                     {/*<SwitchField label="Uncrossing" value={uncrossing} onChange={setUncrossing} />*/}
                  </div>
                  
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Validations Checks:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Trading Account" value={tradingAccount} onChange={setTradingAccount} />

                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("Holdings", holdingsCheck, holdingsOptions, (e) => setHoldingsCheck(e.target.value))}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '2rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Reference Price:
                  </div>

                  <div className="d-flex gap-4">
                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("Option", referencePriceOption, referencePriceOptions, handleReferencePriceOptionChange)}
                        </div>
                     </div>

                     <div>
                        <NarrowInputField label="Percent" value={referencePricePercent} onChange={handleIntegerChange(setReferencePricePercent)} />
                     </div>

                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '2rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Order Values:
                  </div>

                  <div className="d-flex gap-4">

                     <div>
                        <NarrowInputField label="Max value" value={maximumValue} onChange={handleIntegerChange(setMaximumValue)} />
                     </div>
                     <div>
                        <NarrowInputField label="Min Value" value={minimumValue} onChange={handleIntegerChange(setMinimumValue)} />
                     </div>
                     <div>
                        <NarrowInputField label="Hidden %" value={hiddenQtyPercent} onChange={handleIntegerChange(setHiddenQtyPercent)} />
                     </div>

                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Better Validations:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Improve Price" value={betterPrice} onChange={setBetterPrice} />
                     <SwitchField label="Improve Quantity" value={betterQuantity} onChange={setBetterQuantity} />
                  </div>
               </div>

               {/* Pre Function Section */}
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Pre Function:
                  </div>
                  <div className="d-flex gap-4">
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="None (Default)" 
                              value={preFunctionFlags.none ? 'Y' : 'N'} 
                              onChange={(val) => setPreFunctionFlags({ none: val === 'Y' })}
                              disabled={true}  // Pre function only has NONE
                           />
                     </div>
                  </div>
               </div>

               {/* Post Function Section */}
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Post Function Flags:
                  </div>

                  <div className="d-flex flex-column gap-3">

                     {/* First row */}
                     <div className="d-flex gap-4">
                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Close is Last Auction"
                              value={postFunctionFlags.closeIsLastAuctionPrice ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('closeIsLastAuctionPrice')}
                           />
                        </div>

                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Close is LTP"
                              value={postFunctionFlags.closeIsLtp ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('closeIsLtp')}
                           />
                        </div>

                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Close is VWAP"
                              value={postFunctionFlags.closeIsVwap ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('closeIsVwap')}
                           />
                        </div>
                     </div>

                     {/* Second row */}
                     <div className="d-flex gap-4">
                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Cancel Session Orders"
                              value={postFunctionFlags.withdrawSessionOrders ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('withdrawSessionOrders')}
                           />
                        </div>

                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Cancel Day Orders"
                              value={postFunctionFlags.withdrawDayOrders ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('withdrawDayOrders')}
                           />
                        </div>

                        <div style={{ paddingTop: '4px' }}>
                           <SwitchField
                              label="Unload Open Orders"
                              value={postFunctionFlags.removeOpenOrders ? 'Y' : 'N'}
                              onChange={() => togglePostFunctionFlag('removeOpenOrders')}
                           />
                        </div>
                     </div>

                  </div>
               </div>

               {/* Display the current bitmask value 
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Current Values:
                  </div>
                  <div className="d-flex gap-4">
                     <div style={{ paddingTop: '4px', color: '#666', fontSize: '14px' }}>
                           Pre: {getPreFunctionValue()} | Post: {getPostFunctionValue()} (0x{getPostFunctionValue().toString(16)})
                     </div>
                  </div>
               </div>*/}

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Auction Settings:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Start" value={auctionStart} onChange={handleAuctionStartChange} />
                     <SwitchField label="End"   value={auctionEnd}   onChange={handleAuctionEndChange} />

                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                           {RenderDropdown("Type", auctionType, auctionTypeOptions, (e) => setAuctionType(e.target.value))}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Other Settings:
                  </div>

                  <div className="d-flex flex-column">
                     {/* First row */}
                     <div className="d-flex gap-4">
                        <SwitchField
                           label="Load DB Orders"
                           value={loadDBOrders}
                           onChange={setLoadDBOrders}
                        />

                        <SwitchField
                           label="Delete Redundant Orders"
                           value={deleteRedundantOrders}
                           onChange={setDeleteRedundantOrders}
                        />

                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                           {RenderDropdown(
                              "Check Point",
                              checkPoint,
                              checkPointOptions,
                              (e) => setCheckPoint(e.target.value)
                           )}
                        </div>

                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                           {RenderDropdown(
                              "Dump Tables",
                              dumpTables,
                              tableOptions,
                              (e) => setDumpTables(e.target.value)
                           )}
                        </div>
                     </div>

                     {/* Second row */}
                     <div className="d-flex mt-3">
                        <div style={{ minWidth: '220px' }}>
                           {RenderDropdown(
                              "Session Type",
                              sessionType,
                              sessionTypeOptions,
                              (e) => setSessionType(e.target.value)
                           )}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 2: Create TradingRules */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>

               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0rem' }}>
                  <div className="d-flex gap-4">
                     <NarrowInputField label="Code" value={code} onChange={setCode} gap={"6.0rem"} width={'780px'}/>
                  </div>
               </div>

               <div>
                  <NarrowInputField label="Description" value={description} onChange={setDescription} gap={"5.5rem"} width={'780px'}/>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Order Functionality:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Order Entry" value={orderEntry} onChange={setOrderEntry} />
                     <SwitchField label="Order Modify" value={orderModify} onChange={setOrderModify} />
                     <SwitchField label="Order Cancel" value={orderCancel} onChange={setOrderCancel} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Order Types:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Limit" value={limit} onChange={setLimit} />
                     <SwitchField label="Market" value={market} onChange={setMarket} />
                     <SwitchField label="Hidden" value={hidden} onChange={setHidden} />
                     <SwitchField label="Fill or Kill" value={fillOrKill} onChange={setFillOrKill} />
                     <SwitchField label="Schedule" value={sessionOrderType} onChange={setSessionOrderType} />
                     <SwitchField label="Trigger" value={trigger} onChange={setTrigger} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Durations:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Immediate" value={immediate} onChange={setImmediate} />
                     <SwitchField label="Session" value={session} onChange={setSession} />
                     <SwitchField label="Day" value={day} onChange={setDay} />
                     <SwitchField label="GTC" value={gtc} onChange={setGTC} />
                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Matching:
                  </div>
                  
                  <div className="d-flex gap-4">
                     <SwitchField label="Continuous Matching" value={continuousMatching} onChange={setContinuousMatching} />
                     {/*<SwitchField label="Uncrossing" value={uncrossing} onChange={setUncrossing} /> */}
                  </div>    
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Validations Checks:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Trading Account" value={tradingAccount} onChange={setTradingAccount} />

                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("Holdings", holdingsCheck, holdingsOptions, (e) => setHoldingsCheck(e.target.value))}
                        </div>
                     </div>
                     
                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '2rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Reference Price:
                  </div>

                  <div className="d-flex gap-4">
                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("Option", referencePriceOption, referencePriceOptions, handleReferencePriceOptionChange)}
                        </div>
                     </div>

                     <div>
                        <NarrowInputField label="Percent" value={referencePricePercent} onChange={setReferencePricePercent} />
                     </div>

                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '2rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Order Values:
                  </div>

                  <div className="d-flex gap-4">

                     <div>
                        <NarrowInputField label="Max value" value={maximumValue} onChange={handleIntegerChange(setMaximumValue)} />
                     </div>
                     <div>
                        <NarrowInputField label="Min Value" value={minimumValue} onChange={handleIntegerChange(setMinimumValue)} />
                     </div>
                     <div>
                        <NarrowInputField label="Hidden %" value={hiddenQtyPercent} onChange={handleIntegerChange(setHiddenQtyPercent)} />
                     </div>

                  </div>
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Better Validations:
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Improve Price" value={betterPrice} onChange={setBetterPrice} />
                     <SwitchField label="Improve Quantity" value={betterQuantity} onChange={setBetterQuantity} />
                  </div>
               </div>

               {/* Pre Function Section */}
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Pre Function:
                  </div>
                  <div className="d-flex gap-4">
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="None (Default)" 
                              value={preFunctionFlags.none ? 'Y' : 'N'} 
                              onChange={(val) => setPreFunctionFlags({ none: val === 'Y' })}
                              disabled={true}  // Pre function only has NONE
                           />
                     </div>
                  </div>
               </div>

               {/* Post Function Section */}
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Post Function Flags:
                  </div>
                  <div className="d-flex flex-wrap gap-4">
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Close is Last Auction" 
                              value={postFunctionFlags.closeIsLastAuctionPrice ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('closeIsLastAuctionPrice')}
                           />
                     </div>
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Close is LTP" 
                              value={postFunctionFlags.closeIsLtp ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('closeIsLtp')}
                           />
                     </div>
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Close is VWAP" 
                              value={postFunctionFlags.closeIsVwap ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('closeIsVwap')}
                           />
                     </div>
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Cancel Session Orders" 
                              value={postFunctionFlags.withdrawSessionOrders ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('withdrawSessionOrders')}
                           />
                     </div>
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Cancel Day Orders" 
                              value={postFunctionFlags.withdrawDayOrders ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('withdrawDayOrders')}
                           />
                     </div>
                     <div style={{ paddingTop: '4px' }}>
                           <SwitchField 
                              label="Unload Open Orders" 
                              value={postFunctionFlags.removeOpenOrders ? 'Y' : 'N'} 
                              onChange={(val) => togglePostFunctionFlag('removeOpenOrders')}
                           />
                     </div>
                     
                  </div>
               </div>

               {/* Display the current bitmask value
               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px', paddingTop: '6px' }}>
                     Current Values:
                  </div>
                  <div className="d-flex gap-4">
                     <div style={{ paddingTop: '4px', color: '#666', fontSize: '14px' }}>
                           Pre: {getPreFunctionValue()} | Post: {getPostFunctionValue()} (0x{getPostFunctionValue().toString(16)})
                     </div>
                  </div>
               </div> */}

               <div className="d-flex align-items-center mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Auction Settings:
                  </div>
                  <div className="d-flex gap-4">
                     <SwitchField label="Start" value={auctionStart} onChange={handleAuctionStartChange} />
                     <SwitchField label="End"   value={auctionEnd}   onChange={handleAuctionEndChange} />
                     <div
                        className="d-flex align-items-start"
                        style={{
                        marginTop: '4px',      // Pushes dropdown downward a bit more
                        paddingLeft: '4px',    // Adds spacing between the switch and dropdown
                        }}
                     >
                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                        {RenderDropdown("Type", auctionType, auctionTypeOptions, (e) => setAuctionType(e.target.value))}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="d-flex align-items-start mb-3" style={{ gap: '1.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Other Settings:
                  </div>

                  <div className="d-flex flex-column">
                     {/* First row */}
                     <div className="d-flex gap-4">
                        <SwitchField
                           label="Load DB Orders"
                           value={loadDBOrders}
                           onChange={setLoadDBOrders}
                        />

                        <SwitchField
                           label="Delete Redundant Orders"
                           value={deleteRedundantOrders}
                           onChange={setDeleteRedundantOrders}
                        />

                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                           {RenderDropdown(
                              "Check Point",
                              checkPoint,
                              checkPointOptions,
                              (e) => setCheckPoint(e.target.value)
                           )}
                        </div>

                        <div style={{ minWidth: '220px', marginTop: '4px' }}>
                           {RenderDropdown(
                              "Dump Tables",
                              dumpTables,
                              tableOptions,
                              (e) => setDumpTables(e.target.value)
                           )}
                        </div>
                     </div>

                     {/* Second row */}
                     <div className="d-flex mt-3">
                        <div style={{ minWidth: '220px' }}>
                           {RenderDropdown(
                              "Session Type",
                              sessionType,
                              sessionTypeOptions,
                              (e) => setSessionType(e.target.value)
                           )}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>
         </Tabs>
         </div>
      </div>
   );
};

export default TradingRulesAdminForm;
